const config = {
  REACT_APP_GRAPHQL_URL:
    process.env.REACT_APP_GRAPHQL_URL ?? 'http://localhost:4000/graphql',
  REACT_APP_AUTH_URL:
    process.env.REACT_APP_AUTH_URL ?? 'http://localhost:4000/auth'
};

export default config;
